<template>
   <email-field ref="fieldView" v-if="field.type=='user-email'" :userProfile="userProfile" :field="field" :data="data" :validationResults="validationResults"  :disabled="disabled"/>
   <radio-list ref="fieldView" v-else-if="field.type=='radio-list'"  :field="field" :data="data" :validationResults="validationResults"  :disabled="disabled"/>
   <text-field  ref="fieldView" v-else-if="field.type=='text'"  :field="field" :data="data" :validationResults="validationResults" :disabled="disabled" />   
   <span v-else-if="field.type=='label'" ></span>
</template>

  
<script lang="ts">
import { Options, Prop, Vue, Watch } from 'vue-property-decorator';  
import {FormField, FieldValidationResult, validate} from './Forms';
import EmailField from './EmailField.vue';
import TextField from './TextField.vue';
import RadioList from './RadioList.vue'; 
import { UserProfile } from '@/data/repository/UserInfo';
@Options({components:{EmailField,TextField,RadioList}})
export default class FormFieldViewer extends Vue
{
   @Prop() public userProfile!: UserProfile;
   @Prop() public field!: FormField;
   @Prop() public data!: any;
   @Prop({default:false}) public disabled!: boolean;
   public validationResults: FieldValidationResult[] = [];

   public getModelValue(): any
   {
      let value: any = {};
      value[this.field.name] = this.getProxyValue();
      return value;
   }

   public getProxyValue(): string
   {
      let proxyValue= "";

      if (this.$refs.fieldView)
      {
         proxyValue=(this.$refs.fieldView as any).proxyValue;
      }
      return proxyValue;
   }

   public validate(): FieldValidationResult[]
   {
      let proxyValue= this.getProxyValue();
      let obj = {field: this.field, data: this.data, userProfile: this.userProfile, proxyValue: proxyValue};
      this.validationResults= validate(obj); 
      return this.validationResults;
   }
}

</script>